import Vue from 'vue'

export const IDENTITY_SECTIONS = ['payer', 'transmitter', 'receiver']

const capitalize = (section) => section.charAt(0).toUpperCase() + section.slice(1)

const fieldsFor = (section) => {
  const suffix = capitalize(section)
  return {
    name: `${section}Name`,
    realName: `real${suffix}Name`,
    different: `different${suffix}`
  }
}

/** Name shown to drivers and external services (what is stored in payerName/receiverName/transmitterName) */
export function getIdentityName (order, section) {
  if (!order) return ''
  const fields = fieldsFor(section)
  return order[fields.different] ? order[fields.name] || '' : ''
}

/** Real name of the payer/receiver/transmitter, used everywhere in this web app */
export function getRealName (order, section) {
  if (!order) return ''
  const fields = fieldsFor(section)
  if (order[fields.different] && order[fields.realName]) return order[fields.realName]
  return order[fields.name] || ''
}

/** Updates the real name without touching the chosen identity */
export function setRealName (order, section, name) {
  const fields = fieldsFor(section)
  if (order[fields.different] && order[fields.realName]) {
    Vue.set(order, fields.realName, name)
  } else {
    Vue.set(order, fields.name, name)
  }
}

/** Puts the order back on its real name */
export function clearIdentity (order, section) {
  if (!order) return
  const fields = fieldsFor(section)
  if (order[fields.different] && order[fields.realName]) {
    Vue.set(order, fields.name, order[fields.realName])
  }
  Vue.set(order, fields.realName, null)
  Vue.set(order, fields.different, null)
}

/** Shows @identity to drivers and external services while keeping the real name on the order */
export function setIdentity (order, section, identity) {
  const fields = fieldsFor(section)
  const realName = getRealName(order, section)
  const name = typeof identity === 'string' ? identity : ''
  if (!name.trim() || name.trim() === realName) {
    clearIdentity(order, section)
    return
  }
  Vue.set(order, fields.realName, realName)
  Vue.set(order, fields.name, name)
  Vue.set(order, fields.different, true)
}

/** Removes the real names from an order copy that leaves the company */
export function stripIdentities (order) {
  IDENTITY_SECTIONS.forEach(section => {
    const fields = fieldsFor(section)
    delete order[fields.realName]
    delete order[fields.different]
  })
  return order
}
